<template>
    <div class="rsv_search_filter_comp" :style="styleString" v-if="isShow" v-clickoutside:action_ClickOutside="{}">
        <HServiceSearch
            ref="HServiceSearch"
            :fromSheet="true"
        />
    </div>
</template>


<script>
import HServiceSearch from '../../Common/HServiceSearch/HServiceSearch.vue'

import { SHEET_METRICS, sheetState } from '../../../sheet-state'
import { closeHServiceSearch, sheetOverlays } from '../../../sheet-overlays'

export default {
    components: { HServiceSearch },
    data() {
        return {
            sheetState,
            sheetOverlays,
            position: { top: 0, left: 0 }
        }
    },
    watch: {
        isShow: {
            handler: function (newValue) {
                if (newValue == true) {
                    this.$nextTick(() => {
                        this.updateFrame()
                    })
                }
            }
        },
        position: {
            handler: function () {
                this.$nextTick(() => {
                    this.focusInput()
                })
            }
        }
    },
    computed: {
        isShow: function () {
            return this.sheetOverlays.isShowHServiceSearch ?? false
        },
        lastEventPosition: function () {
            return this.sheetOverlays.lastEventPosition ?? { x: 0, y: 0 }
        },
        lastTimeData: function () {
            return this.sheetOverlays.lastTimeData
        },
        topMargin: function () {
            return SHEET_METRICS.defaultTopMargin + this.lastEventPosition.y
        },
        leftMargin: function () {
            return this.lastEventPosition.x
        },
        styleString: function () {
            return `margin-left: ${ this.position.left }px; margin-top: ${ this.position.top }px;`
        }
    },
    methods: {
        action_ClickOutside() {
            closeHServiceSearch()
        },
        focusInput() {
            let el = this.$refs.HServiceSearch?.$refs.search_input?.$refs.input
            if (el != undefined) {
                el.focus()
            }
        },
        updateFrame() {
            let el = this.$el
            if (!el) {
                this.position = { top: this.topMargin, left: this.leftMargin }
            } else {
                let { scrollWidth, scrollHeight } = this.sheetState.sheetScrollElement
                let top = (this.topMargin + el.offsetHeight > scrollHeight) ?
                    (this.topMargin - this.lastTimeData.height - el.offsetHeight) :
                    this.topMargin
                let left = (this.leftMargin + el.offsetWidth > scrollWidth) ?
                    (scrollWidth - el.offsetWidth) :
                    this.leftMargin

                this.position = { top, left }
            }
        }
    }
}
</script>